module.exports = __webpack_public_path__ + "img/title_long_bg.da8e54d1.png";